export default "__VITE_ASSET__1eff07ea__"